<template>
    <div class="statistiques-section">
        <v-row>
            <v-col cols="12" md="6">
                <SexePieChart v-if="statistiques.repartition_sexe_licence"
                    :statistiques="statistiques.repartition_sexe_licence" />
            </v-col>
            <v-col cols="12" md="6">
                <LicencePieChart v-if="statistiques.repartition_sexe_licence"
                    :statistiques="statistiques.repartition_sexe_licence" />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="12">
                <RegionsPieChart v-if="statistiques.repartition_regions"
                    :statistiques="statistiques.repartition_regions" />
            </v-col>
        </v-row>

    </div>
</template>

<script>
import AdminService from "@/services/admin.service";
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import SexePieChart from "./SexePieChart.vue";
import LicencePieChart from "./LicencePieChart.vue";
import RegionsPieChart from "./RegionsPieChart.vue";
export default {
    name: 'StatistiquesSection',
    components: {
        SexePieChart,
        LicencePieChart,
        RegionsPieChart
    },
    data() {
        return {
            statistiques: [],
        }
    },
    computed: {
        ...mapStores(useMainStore),
    },
    methods: {
        async getStatistiques() {
            let request = await AdminService.getStatistiquesInscrits(this.mainStore.module.id);
            if (request) {
                this.statistiques = request;
            }
        }
    },
    async mounted() {
        await this.getStatistiques();
    },



}
</script>

<style scoped></style>
